import { observable, action } from 'mobx';
import { checkIfCustomer, IS_NATIVE_APP_CLIENT } from 'src/scripts/utils/helpers';
import { ExclusiveSaleConfigurations, IExclusiveSaleState } from './types';

export const exclusiveSaleState: IExclusiveSaleState = observable({
  // Initial state
  membersExclusiveState: {
    isEnabled: false,
    guestUserDiscountCopy: '',
    guestUserDiscountCopyColor: '',
    memberExclusivePercentageBadgeColor: '',
  },
  appOnlySaleState: {
    isEnabled: false,
    appOnlySaleDiscountCopyColor: '',
    appOnlySaleDiscountCopy: '',
  },
  isConfigFetched: false,

  get getExclusiveSaleVisibility() {
    const isLoggedIn = checkIfCustomer();
    const appOnlySale = exclusiveSaleState.appOnlySaleState.isEnabled;
    const memberExclusive = exclusiveSaleState.membersExclusiveState.isEnabled;

    if (appOnlySale && !IS_NATIVE_APP_CLIENT) {
      return {
        memberBadge: false,
        pricing: true,
      };
    }

    let memberBadge = false;
    let pricing = false;

    if (memberExclusive) {
      if (isLoggedIn) {
        memberBadge = true;
        pricing = false;
      } else {
        memberBadge = false;
        pricing = true;
      }
    }

    return {
      memberBadge,
      pricing,
    };
  },

  setExclusiveSaleState: action(async function (data: ExclusiveSaleConfigurations) {
    exclusiveSaleState.membersExclusiveState = {
      isEnabled: data.membersExclusive?.membersExclusiveEnabled || false,
      guestUserDiscountCopy: data?.membersExclusive?.guestUserDiscountCopy || '',
      guestUserDiscountCopyColor: data?.membersExclusive?.guestUserDiscountCopyColor || '',
      memberExclusivePercentageBadgeColor: data?.membersExclusive?.memberExclusivePercentageBadgeColor || '',
    };
    exclusiveSaleState.appOnlySaleState = {
      isEnabled: data.appOnlySale?.appOnlySaleEnabled || false,
      appOnlySaleDiscountCopyColor: data?.appOnlySale?.appOnlySaleDiscountCopyColor || '',
      appOnlySaleDiscountCopy: data?.appOnlySale?.appOnlySaleDiscountCopy || '',
    };
    exclusiveSaleState.isConfigFetched = true;
  }),
});
